export default defineNuxtRouteMiddleware(async (to) => {
	const localePath = useLocalePath()
	const locale = usei18nService()?.getLocaleLang()
	const locationURLSlug = to.params.urlSlug

	try {
		const data = await useRentalLocationPagesStore().fetchCmsLocationBySlug(locationURLSlug as string, locale)
		if (data?.[`isActive${locale.toUpperCase()}`] === false) {
			navigateTo(localePath('/'))
		}
	} catch (error) {
		navigateTo(localePath('/'), { redirectCode: 301 })
	}
})
